<div class="d-flex flex-column justify-content-center align-items-center flex-grow-1">
  <div class="d-flex flex-column align-items-center">
    <h4 class="text-center fw-medium text-nowrap">
      {{ 'logout_title' | translate }}
    </h4>

    <p class="w-auto d-inline-block fw-normal text-center mt-1 px-3">
      <span>
        {{ 'logout_msg_1' | translate }}
      </span>
      @if (showReturnToPortalButton()) {
        <span class="d-block">
          {{ 'logout_msg_2' | translate: getTenantName() | titlecase }}
        </span>
      }
    </p>

    @if (showReturnToPortalButton()) {
      <button class="btn btn-primary" (click)="redirectToPortal()">
        <span class="d-inline-block px-1 text-nowrap">
          {{
            isDevEnvironment() ? ('return_to_login' | translate) : ('return_to_portal' | translate)
          }}
        </span>
      </button>
    }
  </div>
</div>
